var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { Select as MuiSelect, Box, selectClasses, styled } from '@mui/material';
import Input from '../Input';
import { ArrowDropDownIcon } from '../icons';
import Chip from '../Chip';
import MenuItem from '../MenuItem';
var SelectRoot = styled(MuiSelect)(function (_a) {
    var _b, _c, _d;
    var size = _a.size, disabled = _a.disabled;
    return __assign(__assign((_b = {}, _b["& ." + selectClasses.icon] = {
        color: 'rgba(0, 0, 0, 0.56)'
    }, _b), (disabled && (_c = {},
        _c["& ." + selectClasses.icon] = {
            color: 'rgba(0, 0, 0, 0.26)'
        },
        _c))), (_d = {}, _d["& ." + selectClasses.select] = __assign(__assign({}, (size === 'small' && {
        padding: '6.5px 12px 6.5px 12px',
    })), (size === 'large' && {
        padding: '12.5px 12px 12.5px 12px',
    })), _d));
});
var Select = React.forwardRef(function (props, ref) {
    var label = props.label, valueProp = props.value, childrenProp = props.children, options = props.options, multiple = props.multiple, MenuProps = props.MenuProps, SelectProps = __rest(props, ["label", "value", "children", "options", "multiple", "MenuProps"]);
    var children = useMemo(function () {
        if (childrenProp != null)
            return childrenProp;
        return options.map(function (_a) {
            var label = _a.label, value = _a.value;
            return React.createElement(MenuItem, { key: value + "-" + label, multiple: multiple, value: value, text: label });
        });
    }, [options, childrenProp, valueProp]);
    var optionMaps = useMemo(function () {
        var _maps = {};
        for (var i = 0; i < (options === null || options === void 0 ? void 0 : options.length); i++) {
            var _a = options[i], value = _a.value, label_1 = _a.label;
            _maps[value] = label_1;
        }
        return _maps;
    }, [options]);
    return (React.createElement(SelectRoot, __assign({ ref: ref, value: valueProp, input: React.createElement(Input, { label: label }), multiple: multiple, MenuProps: __assign({ PaperProps: {
                sx: {
                    padding: 0,
                }
            } }, MenuProps), renderValue: function (value) {
            if (Array.isArray(value)) {
                return (React.createElement(Box, { sx: { margin: SelectProps.size !== "small" ? '-5px 3px -5px 0px' : '-1px 3px -1px 0px' } }, value === null || value === void 0 ? void 0 : value.map(function (v) { return React.createElement(Chip, { sx: { mr: '3px' }, size: SelectProps.size === "small" ? 'medium' : 'large', label: optionMaps[v] }); })));
            }
            return optionMaps[value];
        } }, SelectProps), children));
});
Select.defaultProps = {
    options: [],
    IconComponent: ArrowDropDownIcon,
    fullWidth: true,
};
export default Select;
